/**
 * Centralized translations for Dashboard module
 * Contains all labels used across dashboard components
 */

export const DashboardLabels = {
    it: {
        // Navigation and breadcrumb
        home: 'Home',
        dashboard: 'Dashboard',
        
        // Main title and subtitle
        aiPlanIpc: 'AI PLAN IPC',
        platformDescription: 'La piattaforma intelligente per digitalizzare, monitorare e migliorare la gestione dell\'igiene e dei flussi sanitari.',
        
        // Cards and sections
        whatDoesAiPlanDo: 'Cosa Fa AI PLAN?',
        aiPlanDescription1: 'AI PLAN IPC è una piattaforma innovativa progettata per supportare le strutture sanitarie nella digitalizzazione e ottimizzazione dei loro flussi operativi quotidiani, con particolare attenzione alla gestione dell\'igiene delle mani, seguendo le linee guida dell\'OMS.',
        aiPlanDescription2: 'Facilita la tracciabilità dei processi cruciali per la sicurezza e la salute, assicurando conformità alle normative e alle best practices internazionali.',
        aiPlanDescription3: 'Automatizza i flussi relativi all\'igiene delle mani, registra attività di disinfezione, raccoglie dati e genera report per il monitoraggio delle performance sanitarie.',
        aiPlanDescription4: 'Digitalizza questionari e documentazione obbligatoria, migliorando efficienza e riducendo gli errori umani.',
        aiPlanDescription5: 'I dati raccolti possono essere analizzati in profondità, supportando la formazione continua e il miglioramento degli standard qualitativi.',
        aiPlanConclusion: 'In questo modo, AI PLAN IPC diventa uno strumento essenziale per migliorare la qualità del servizio sanitario, monitorare costantemente i flussi di lavoro e rispondere in modo tempestivo a eventuali criticità, il tutto in modo conforme alle linee guida internazionali.',
        
        // Benefits cards
        operationalSecurity: 'Sicurezza Operativa',
        operationalSecurityDesc: 'Monitoraggio in tempo reale e risposta rapida alle non conformità.',
        analysisAndReports: 'Analisi e Report',
        analysisAndReportsDesc: 'Dati sempre disponibili per analisi, valutazione e miglioramento continuo.',
        digitalization: 'Digitalizzazione',
        digitalizationDesc: 'Compilazioni automatizzate e gestione intelligente della documentazione sanitaria.',
        
        // Tabs
        requirements: 'Requisiti',
        indicators: 'Indicatori',
        activities: 'Attività',
        effectiveness: 'Efficacia',


         // AI PLAN AVA3
         aiPlanAva3Title: 'AI PLAN AVA3',
         aiPlanAva3Description: 'AI PLAN AVA3 è una piattaforma intelligente per la gestione e l’ottimizzazione dei processi accademici e amministrativi.',
         whatDoesAiPlanAva3Do: 'Cosa Fa AI PLAN AVA3?',
         aiPlanAva3Description1 : 'AIPLAN è una piattaforma intelligente per la gestione e l’ottimizzazione dei processi accademici e amministrativi.' ,
         aiPlanAva3Description2: 'Automatizza flussi complessi (mobilità internazionale, accordi, utenti, documenti, workflow interni), centralizza i dati e supporta le decisioni grazie a moduli AI integrati.',
         aiPlanAva3Description3:'È pensata per università e organizzazioni strutturate che vogliono ridurre burocrazia, errori e tempi operativi, offrendo un sistema moderno, modulare e scalabile, accessibile via web e integrabile con sistemi esistenti.' ,
         aiPlanAva3Conclusion: 'In sintesi: AIPLAN trasforma la gestione istituzionale in un processo digitale, fluido e guidato dall’intelligenza artificiale.' ,
         digitalizationDescAva3: 'Compilazioni automatizzate e gestione intelligente della documentazione universitaria.',
        // Chart titles
        coveragePercentage: 'Copertura %',
        evaluatedRequirementsPercentage: 'Requisiti valutati %',
        compliancePercentage: 'Conformità %',
        trend: 'Andamento',
        
        // Form labels
        selectIndicator: 'Seleziona un indicatore',
        indicator: 'Indicatore',
        structure: 'Struttura',
        category: 'Categoria',
        all: 'Tutte',
        search: 'Cerca',
        activity: 'Attività',
        title: 'Titolo',
        typology: 'Tipologia',
        status: 'Stato',
        
        // Chart labels
        percentage: 'Percentuale',
        headquarters: 'Sede',
        cds: 'Cds',
        cdsMed: 'Cds Med',
        doctorates: 'Dottorati',
        departments: 'Dipartimenti',
        
        // Efficiency metrics
        efficiency: 'Efficienza',
        impact: 'Impatto'
    },
    
    en: {
        // Navigation and breadcrumb
        home: 'Home',
        dashboard: 'Dashboard',
        
        // Main title and subtitle
        aiPlanIpc: 'AI PLAN IPC',
        platformDescription: 'The intelligent platform to digitize, monitor and improve the management of hygiene and health flows.',

       
    
        
        // Cards and sections
        whatDoesAiPlanDo: 'What Does AI PLAN Do?',
        aiPlanDescription1: 'AI PLAN IPC is an innovative platform designed to support healthcare facilities in digitizing and optimizing their daily operational flows, with particular attention to hand hygiene management, following WHO guidelines.',
        aiPlanDescription2: 'It facilitates the traceability of crucial processes for safety and health, ensuring compliance with international regulations and best practices.',
        aiPlanDescription3: 'It automates flows related to hand hygiene, records disinfection activities, collects data and generates reports for monitoring health performance.',
        aiPlanDescription4: 'It digitizes mandatory questionnaires and documentation, improving efficiency and reducing human errors.',
        aiPlanDescription5: 'The collected data can be analyzed in depth, supporting continuous training and improvement of quality standards.',
        aiPlanConclusion: 'In this way, AI PLAN IPC becomes an essential tool to improve the quality of health services, constantly monitor workflows and respond promptly to any critical issues, all in compliance with international guidelines.',

        // AI PLAN AVA3
        aiPlanAva3Title: 'AI PLAN AVA3',
        aiPlanAva3Description: 'AI PLAN AVA3 is an intelligent platform for the management and optimization of academic and administrative processes',
        whatDoesAiPlanAva3Do: 'What Does AI PLAN AVA3 Do?',
        aiPlanAva3Description1 : 'AIPLAN is an intelligent platform for the management and optimization of academic and administrative processes' ,
        aiPlanAva3Description2: 'It automates complex workflows (international mobility, agreements, users, documents, internal workflows), centralizes data, and supports decision-making through integrated AI modules',
        aiPlanAva3Description3:'Designed for universities and structured organizations aiming to reduce bureaucracy, errors, and operational time, it offers a modern, modular, and scalable system that is web-accessible and integrates seamlessly with existing systems.' ,
        aiPlanAva3Conclusion: 'In summary: AIPLAN transforms institutional management into a digital, fluid, and AI-driven process.' ,
        digitalizationDescAva3: 'Automated completion and intelligent management of university documentation.',
        // Benefits cards
        operationalSecurity: 'Operational Security',
        operationalSecurityDesc: 'Real-time monitoring and rapid response to non-compliance.',
        analysisAndReports: 'Analysis and Reports',
        analysisAndReportsDesc: 'Data always available for analysis, evaluation and continuous improvement.',
        digitalization: 'Digitalization',
        digitalizationDesc: 'Automated completion and intelligent management of health documentation.',
        
        // Tabs
        requirements: 'Requirements',
        indicators: 'Indicators',
        activities: 'Activities',
        effectiveness: 'Effectiveness',
        
        // Chart titles
        coveragePercentage: 'Coverage %',
        evaluatedRequirementsPercentage: 'Evaluated Requirements %',
        compliancePercentage: 'Compliance %',
        trend: 'Trend',
        
        // Form labels
        selectIndicator: 'Select an indicator',
        indicator: 'Indicator',
        structure: 'Structure',
        category: 'Category',
        all: 'All',
        search: 'Search',
        activity: 'Activity',
        title: 'Title',
        typology: 'Typology',
        status: 'Status',
        
        // Chart labels
        percentage: 'Percentage',
        headquarters: 'Headquarters',
        cds: 'Cds',
        cdsMed: 'Cds Med',
        doctorates: 'Doctorates',
        departments: 'Departments',
        
        // Efficiency metrics
        efficiency: 'Efficiency',
        impact: 'Impact'
    }
}; 